import { inject, Injectable } from "@angular/core"
import { ServiceBusService } from "./serviceBus.service"

@Injectable({ providedIn: 'root' }) export class DataRefreshService {
    constructor(private readonly _serviceBusService: ServiceBusService) {
        setInterval(() => this._serviceBusService.fullRefresh.next(), 10 * 60 * 1000)
    }
}